import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const InstagramFeed = ({ posts }) => {
  return (
    <div className="bg-card rounded-2xl p-8 shadow-warm">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 flex items-center justify-center">
            <Icon name="Instagram" size={24} color="white" />
          </div>
          <div>
            <h3 className="font-serif text-xl font-semibold text-foreground">@montesantobakery</h3>
            <p className="text-sm text-muted-foreground">Follow us for daily fresh creations</p>
          </div>
        </div>
        <a
          href="https://instagram.com/montesantobakery"
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-medium hover:shadow-lg transition-all duration-300 flex items-center gap-2"
        >
          <Icon name="ExternalLink" size={16} />
          Follow
        </a>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {posts?.map((post, index) => (
          <a
            key={index}
            href={post?.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative aspect-square rounded-lg overflow-hidden bg-muted"
          >
            <Image
              src={post?.image}
              alt={post?.imageAlt}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <div className="flex items-center gap-4 text-white">
                <div className="flex items-center gap-1">
                  <Icon name="Heart" size={20} className="fill-current" />
                  <span className="text-sm font-medium">{post?.likes}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="MessageCircle" size={20} />
                  <span className="text-sm font-medium">{post?.comments}</span>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default InstagramFeed;